export default function () {
    let pathname = location.pathname;
    if (pathname.substring(0, 2) === '//') {
        pathname = pathname.slice(1);
    }

    return [pathname, location.search, location.hash].join('');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/full-path.js